import React from 'react'
import { connect } from 'react-redux'
import { setSelectedNote, updateModalContent } from '../redux/FeedbackRedux'
import DateFormatter from '../Classes/DateFormatter'

class FeedbackNote extends React.Component {
	constructor(props) {
		super(props);
		this.handleEditClick = this.handleEditClick.bind(this);
	}

    handleEditClick(event) {
        event.preventDefault();
        const modal_id = "textForwardModal";
        const modal_title = __('Edit Note');
        const modal_body = "renderEditNote";
        const button_1_class = "danger mr-sm-auto";
        const button_1_id = "deleteNote";
        const button_1_text = __('Delete Note');
        const button_2_class = "primary";
        const button_2_id = "updateNote";
        const button_2_text = __('Save Changes');
        this.props.dispatch(setSelectedNote({note: this.props.note}));
		this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
		jQuery('.modal:not(.error)').modal();
    }

	render () {
        const formattedTime = DateFormatter.formatDate(this.props.note.created_at, this.props.state.business.call_at_timezone, this.props.state.app_locale);

		if(this.props.note.user){
			return (
				<div className={"col-md-12 mt-1 mb-3 note " + this.props.classes}>
					<h5 className="text-muted font-weight-normal" style={{lineHeight:1}}>{this.props.note.note}</h5>
					<h6 className="mt-1">{this.props.note.user.firstname + " " + this.props.note.user.lastname}: { formattedTime }{this.props.state.current_user && <a href="#" onClick={this.handleEditClick}><i className="far fa-edit text-primary ml-1 mr-1"></i>{ __('Edit') }</a>}</h6>
				</div>
			);
		} else {
			return (
				<div className={"col-md-12 mt-1 mb-3 note " + this.props.classes}>
					<h5 className="text-muted font-weight-normal" style={{lineHeight:1}}>{this.props.note.note}</h5>
					<h6 className="mt-1">{this.props.note.user_name}: { formattedTime } { __('(External Note)') }{ this.props.state.current_user && <a href="#" onClick={this.handleEditClick}><i className="far fa-edit text-primary ml-1 mr-1"></i>{ __('Edit') }</a>}</h6>
				</div>
			);
		}
	}
}

function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(FeedbackNote);
